import p from "./index49.js";
import x from "./index66.js";
import E from "./index67.js";
import I from "./index68.js";
import b from "./index52.js";
import O from "./index69.js";
import y from "./index70.js";
import A from "./index63.js";
import S from "./index71.js";
const s = y.validators;
class q {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new E(),
      response: new E()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, e) {
    try {
      return await this._request(t, e);
    } catch (r) {
      if (r instanceof Error) {
        let l = {};
        Error.captureStackTrace ? Error.captureStackTrace(l) : l = new Error();
        const a = (() => {
          if (!l.stack)
            return "";
          const u = l.stack.indexOf(`
`);
          return u === -1 ? "" : l.stack.slice(u + 1);
        })();
        try {
          if (!r.stack)
            r.stack = a;
          else if (a) {
            const u = a.indexOf(`
`), i = u === -1 ? -1 : a.indexOf(`
`, u + 1), f = i === -1 ? "" : a.slice(i + 1);
            String(r.stack).endsWith(f) || (r.stack += `
` + a);
          }
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, e) {
    typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = b(this.defaults, e);
    const { transitional: r, paramsSerializer: l, headers: a } = e;
    r !== void 0 && y.assertOptions(
      r,
      {
        silentJSONParsing: s.transitional(s.boolean),
        forcedJSONParsing: s.transitional(s.boolean),
        clarifyTimeoutError: s.transitional(s.boolean),
        legacyInterceptorReqResOrdering: s.transitional(s.boolean),
        advertiseZstdAcceptEncoding: s.transitional(s.boolean),
        validateStatusUndefinedResolves: s.transitional(s.boolean)
      },
      !1
    ), l != null && (p.isFunction(l) ? e.paramsSerializer = {
      serialize: l
    } : y.assertOptions(
      l,
      {
        encode: s.function,
        serialize: s.function
      },
      !0
    )), e.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? e.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : e.allowAbsoluteUrls = !0), y.assertOptions(
      e,
      {
        baseUrl: s.spelling("baseURL"),
        withXsrfToken: s.spelling("withXSRFToken")
      },
      !0
    ), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let u = a && p.merge(a.common, a[e.method]);
    a && p.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (n) => {
      delete a[n];
    }), e.headers = A.concat(u, a);
    const i = [];
    let f = !0;
    this.interceptors.request.forEach(function(o) {
      if (typeof o.runWhen == "function" && o.runWhen(e) === !1)
        return;
      f = f && o.synchronous;
      const w = e.transitional || S;
      w && w.legacyInterceptorReqResOrdering ? i.unshift(o.fulfilled, o.rejected) : i.push(o.fulfilled, o.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(o) {
      m.push(o.fulfilled, o.rejected);
    });
    let h, d = 0, c;
    if (!f) {
      const n = [I.bind(this), void 0];
      for (n.unshift(...i), n.push(...m), c = n.length, h = Promise.resolve(e); d < c; )
        h = h.then(n[d++], n[d++]);
      return h;
    }
    c = i.length;
    let R = e;
    for (; d < c; ) {
      const n = i[d++], o = i[d++];
      try {
        R = n(R);
      } catch (w) {
        o.call(this, w);
        break;
      }
    }
    try {
      h = I.call(this, R);
    } catch (n) {
      return Promise.reject(n);
    }
    for (d = 0, c = m.length; d < c; )
      h = h.then(m[d++], m[d++]);
    return h;
  }
  getUri(t) {
    t = b(this.defaults, t);
    const e = O(t.baseURL, t.url, t.allowAbsoluteUrls, t);
    return x(e, t.params, t.paramsSerializer);
  }
}
p.forEach(["delete", "get", "head", "options"], function(t) {
  q.prototype[t] = function(e, r) {
    return this.request(
      b(r || {}, {
        method: t,
        url: e,
        data: r && p.hasOwnProp(r, "data") ? r.data : void 0
      })
    );
  };
});
p.forEach(["post", "put", "patch", "query"], function(t) {
  function e(r) {
    return function(a, u, i) {
      return this.request(
        b(i || {}, {
          method: t,
          headers: r ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: a,
          data: u
        })
      );
    };
  }
  q.prototype[t] = e(), t !== "query" && (q.prototype[t + "Form"] = e(!0));
});
const M = q;
export {
  M as default
};
